<script setup>
const { statusType } = defineProps({
  statusType: {
    type: String,
    default: 'standard',
  },
});
</script>

<template>
  <div
    class="flex items-center ring-inset ring-2 ring-neutral-200 shadow-mini rounded-3xl"
    :class="{
      'bg-cancelled text-white': statusType === 'warning',
      'bg-white': statusType !== 'warning',
    }"
  >
    <slot></slot>
  </div>
</template>
